require('frontend-controller/client/run')(
    require('./clientAppConfig'),
    {
        templates:      require.context('./components/', true, /^\.\/(?!layouts\/mail\/).*(?<!\.pdf)\.ejs$/),
        components:     require.context('./components/', true, /^\.\/(?!layouts\/mail\/).*(?<!\.pdf)\.js$/),
        styles:         require.context('./components/', true, /^\.\/(?!layouts\/mail\/).*(?<!\.pdf)\.less$/),
        translations:   require.context('./i18next/', true, /^\.\/.*\.js$/),
    },
    () => {
        // init vendors
        require('gsap/TweenMax')
        require('gsap/Draggable')
        require('./vendor/ckeditor/index')
    }
)
